import React, { useContext, useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { formatDateTime } from '../../../utils/dateTimeFormate';
import { getAllRegistrationList } from '../../../services/adminApiService/individualApiService/IndividualAPiService';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import useSearchValue from '../../../hooks/useSearchValue';
import CategorySubCategoryFilter from '../categorySubCateogoryFilter/CategorySubCategoryFilter';
import DistrictFilter from '../districtFilter/DistrictFilter';
import BlockFilter from '../districtFilter/BlockFilter';
import { LocationContext } from '../../../context/LocationContext';
import { useCategoryFilter } from '../../../context/CategoryFilterContext';
import { useFilterReset } from '../../../hooks/useFilterReset';
import RefreshButton from '../../../jsx/components/RefreshButton/RefreshButton';
import { useSport } from '../../../context/SportContext';
import SportFilter from '../sportFilter/SportFilter';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FaChevronDown } from "react-icons/fa";
import TextMasked from '../../../utils/TextMasked';
import { formatStatus, getStatusColor } from '../../../utils/colorAsperStatus';
import BulkAtomIdLookupModal from './BulkAtomIdLookupModal';

const AllRegistrationList = () => {
    const [registrationList, setRegistrationList] = useState([]);
    const [showBulkLookup, setShowBulkLookup] = useState(false);
    const { selectedDistrictId, setSelectedDistrictId, selectedBlockId, setSelectedBlockId } = useContext(LocationContext);
    const { selectedSubCategoryId, setSelectedSubCategoryId } = useCategoryFilter();
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
    const [selectedCategory, setSelectedCategory] = useState('');
    const [selectedSubCategory, setSelectedSubCategory] = useState('');
    const { selectedSportId, setSelectedSportId } = useSport();
    const [selectedYear, setSelectedYear] = useState(null);
    const yearValue = selectedYear ? selectedYear.getFullYear() : '';

    const handleViewClick = (id) => {
        navigate(`/verification-Individual-form/${id}`);
    };

    const getRegistrationListApi = async (perPage, currentPage, searchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId, yearValue, selectedBlockId) => {
        setLoading(true);
        try {
            const response = await getAllRegistrationList(perPage, currentPage, searchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId, yearValue, selectedBlockId);
            setRegistrationList(response?.data?.data);
        } catch (error) {
            console.error('Registration list error:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getRegistrationListApi(perPage, currentPage, debouncedSearchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId, yearValue, selectedBlockId);
    }, [currentPage, perPage, debouncedSearchValue, selectedDistrictId, selectedCategory, selectedSubCategoryId, selectedSportId, yearValue, selectedBlockId]);

    const handlePageChange = (event) => {
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };

    const handleRefresh = useFilterReset({
        setSearchValue,
        setDebouncedSearchValue,
        setSelectedDistrictId,
        setSelectedBlockId,
        setSelectedSubCategoryId,
        setSelectedCategory,
        setSelectedSubCategory,
        setPerPage,
        setCurrentPage,
        setSelectedYear,
        setSelectedSportId,
        fetchFunction: getRegistrationListApi,
        fetchArgs: [10, 1, "", "", "", "", "", "", ""]
    });

    useEffect(() => {
        setCurrentPage(1);
        setPerPage(10);
        setDebouncedSearchValue("");
        setSelectedDistrictId("");
        setSelectedBlockId("");
        setSelectedSubCategoryId("");
        setSelectedSportId("");
    }, []);

    return (
        <>
            <PageTitle activeMenu="All Registrations" motherMenu="Dashboard" />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 d-flex justify-content-between">
                        <div className="d-flex mt-3 mx-2">
                            <div>
                                <FilterNumber value={perPage} onChange={(val) => {
                                    setPerPage(val);
                                    setCurrentPage(1)
                                }} />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                        <div className="d-flex mt-3">
                            <div className="me-2">
                                <Button variant="outline-primary" onClick={() => setShowBulkLookup(true)}>
                                    Bulk Atom Id Lookup
                                </Button>
                            </div>
                            <div>
                                <RefreshButton refreshCallback={handleRefresh} />
                            </div>
                        </div>
                    </div>
                    <div className="mx-4 d-flex mt-2 ">
                        <div>
                            <SportFilter setCurrentPage={setCurrentPage} />
                        </div>
                        <div className="ms-2">
                            <DistrictFilter setCurrentPage={setCurrentPage} />
                        </div>
                        <div className="ms-2">
                            <BlockFilter setCurrentPage={setCurrentPage} />
                        </div>

                        <div className="date-picker-wrapper mx-2">
                            <DatePicker
                                selected={selectedYear}
                                onChange={(date) => setSelectedYear(date)}
                                showYearPicker
                                dateFormat="yyyy"
                                placeholderText="Select Dob Year"
                                className="form-control custom-datepicker"
                            />
                            <FaChevronDown className="datepicker-icon" />
                        </div>

                        <div className="mx-2">
                            <CategorySubCategoryFilter typeId="1"
                                selectedCategory={selectedCategory}
                                setSelectedCategory={setSelectedCategory}
                                selectedSubCategory={selectedSubCategory}
                                setSelectedSubCategory={setSelectedSubCategory}
                                placeholderText="Individual"
                                setCurrentPage={setCurrentPage}
                            />
                        </div>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 table-responsive">
                                <div id="example_wrapper" className="dataTables_wrapper">
                                    <table id="example" className="display w-100 dataTable">
                                        <thead>
                                            <tr>
                                                <th>SN</th>
                                                <th>Atom Id</th>
                                                <th>Applicant Full Name</th>
                                                <th>Sport Name</th>
                                                <th>Contact Number</th>
                                                <th>Registration Date</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {registrationList?.data?.length > 0 ? (
                                                registrationList.data.map((data, index) => {
                                                    const serialNumber = (currentPage - 1) * perPage + (index + 1);
                                                    return (
                                                        <tr key={index}>
                                                            <td>{serialNumber}</td>
                                                            <td>{data?.atom_id}</td>
                                                            <td>{data?.name}</td>
                                                            <td>{data?.refsport?.sport_name}</td>
                                                            <td><TextMasked value={data?.mobile} type="phone" /></td>
                                                            <td>{formatDateTime(data?.created_at)}</td>
                                                            <td>
                                                                <span style={{ color: getStatusColor(data?.status) }}>
                                                                    {data?.status ? formatStatus(data.status) : ''}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex">
                                                                    <Button style={{ whiteSpace: 'nowrap' }} onClick={() => handleViewClick(data?.id)}> View More </Button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">Data is not available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={Math.ceil(registrationList?.total / perPage)}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />
            </div>
            <BulkAtomIdLookupModal
                show={showBulkLookup}
                onHide={() => setShowBulkLookup(false)}
                onViewRecord={handleViewClick}
            />
        </>
    )
}

export default AllRegistrationList
